import {
  FlexGrid,
  FlexGridColumn,
  FlexGridCellTemplate,
} from "@grapecity/wijmo.react.grid";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";

const QubGenGrid = (props) => {
  const { columns, gridData, initialized, cellTemplateColumns = [] } = props;

  console.log(gridData);

  return (
    <FlexGrid
      initialized={initialized}
      itemsSource={gridData}
      autoSizeMode={1}
      isReadOnly
      headersVisibility={3}
      alternatingRowStep={0}
      {...props}
      className="explorer-grid"
    >
      <FlexGridFilter />
      {columns.length > 0 &&
        columns.map((c, index) => (
          <FlexGridColumn
            key={index}
            binding={c.binding}
            header={c.header ?? c.binding}
            className="explorer-column"
            width={c.width ?? null}
          />
        ))}
      {cellTemplateColumns.length > 0 &&
        cellTemplateColumns.map((c, index) => (
          <FlexGridColumn
            key={index}
            binding={c.binding}
            header={c.header ?? c.binding}
            className="explorer-column"
          />
        ))}
    </FlexGrid>
  );
};

export default QubGenGrid;
